import { Component, Input, Output, EventEmitter } from '@angular/core';
import { HireItem, Product } from '../../models';
import { MatIcon } from '@angular/material/icon';
import { NgClass } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-pricing-type-label',
  template: `
    <div class="flex items-center gap-2">
      <span [ngClass]="bgColor + ' rounded px-2 py-1 flex items-center gap-1'">
        <mat-icon [ngClass]="iconColor">{{ icon }}</mat-icon>
        <span class="font-medium">{{ label }}</span>
      </span>
      @if (showEditIcon) {
        <button
          mat-icon-button
          (click)="edit.emit()"
          [attr.aria-label]="'Edit pricing type'"
        >
          <mat-icon>edit</mat-icon>
        </button>
      }
    </div>
  `,
  standalone: true,
  imports: [
    // Angular Material and common modules
    MatIcon,
    NgClass,
    MatButtonModule
  ]
})
export class PricingTypeLabelComponent {
  @Input()
  set pricingType(value: string) {
    this.icon = this.resolveIcon(value);
    this.iconColor = this.resolveIconColor(value);
    this.bgColor = this.resolveBgColor(value);
    this.label = this.resolveLabel(value);
  }

  @Output() edit = new EventEmitter<void>();

  @Input() showEditIcon = true;

  icon: string;
  iconColor: string;
  bgColor: string;
  label: string;

  private resolveIcon(type: string): string {
    switch (type) {
      case 'fixed':
        return 'lock';
      case 'custom':
        return 'tune';
      case 'no_charge':
        return 'money_off';
      default:
        return 'star';
    }
  }

  private resolveLabel(type: string): string {
    switch (type) {
      case 'fixed':
        return 'Fixed Price';
      case 'custom':
        return 'Custom Pricing';
      case 'no_charge':
        return 'No Charge';
      default:
        return 'Default Pricing';
    }
  }

  private resolveBgColor(type: string): string {
    switch (type) {
      case 'fixed':
        return 'bg-blue-100';
      case 'custom':
        return 'bg-green-100';
      case 'no_charge':
        return 'bg-red-100';
      default:
        return 'bg-yellow-100';
    }
  }

  private resolveIconColor(type: string): string {
    switch (type) {
      case 'fixed':
        return 'text-blue-500';
      case 'custom':
        return 'text-green-500';
      case 'no_charge':
        return 'text-red-500';
      default:
        return 'text-yellow-500';
    }
  }
}
